import { FormControl, MenuItem, Select } from '@mui/material';
import { currencies } from 'common/constants';
import { Currency } from 'common/types';

export interface CurrencySelectorProps {
  value?: Currency;
  onChange: (value: Currency) => void;
}

const CurrencySelector = ({ value, onChange }: CurrencySelectorProps) => {
  const handleChange = (event: any) => {
    const newCurrency = event.target.value as Currency;
    onChange(newCurrency);
  };

  return (
    <FormControl>
      <Select
        variant="standard"
        value={value ?? 'uah'}
        id={`currency-selector`}
        name={`currency-selector`}
        MenuProps={{
          id: `menu`,
          sx: {
            maxHeight: '300px'
          }
        }}
        renderValue={() => <>{currencies[value ?? 'uah']?.symbol ?? ''}</>}
        onChange={handleChange}
      >
        {Object.values(currencies).map(currency => (
          <MenuItem key={currency.code} value={currency.code}>
            {currency.code} - {currency.symbol}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencySelector;
